// components/Meter/Meter.tsx

import "./Meter.style.scss";

import React from "react";

// export interface MeterProps {
//   id?: string;
//   value?: number;
//   label?: string;
//   size?: number;
//   stroke?: number;
// }

const defaultProps = {
	customValue: 0,
	value: 0,
	size: 170,
	stroke: 5,
};

const Meter = (props) => {
	props = { ...defaultProps, ...props };

	props.size = props.size || 200;
	props.stroke = props.stroke || 5;

	const getColor = () => {
		if (props.value >= 75) {
			return "rgb(129, 202, 178)";
		}
		if (props.value >= 60) {
			return "rgb(224,199,94)";
		}
		if (props.value >= 50) {
			return "rgba(248, 183, 116, 1)";
		}
		return "rgba(255, 0, 0, 1)";
	};

	const meterStyle = {
		"--s": props.size,
		"--b": props.stroke,
		"--v": props.value,
		"--c": getColor(),
		width: `${props.size}px`,
		minWidth: `${props.size}px`,
		maxWidth: `${props.size}px`,
		height: `${props.size}px`,
		maxHeight: `${props.size}px`,
		minHeight: `${props.size}px`,
	};

	return (
		<div id={props.id} className='meter' data-testid='Meter' style={meterStyle}>
			<div className='ring' />
			<div className='donut-segment' />
			<div className='hole' />
			<div className='meter-content'>
				<div className='meter-value'>{props.customValue ? props.customValue : props.value}</div>
				{props.label && <div className='meter-label'>{props.label}</div>}
			</div>
		</div>
	);
};

export default Meter;
